import React from 'react';
import { NavLink } from 'react-router-dom';
import {
    Calendar,
    CreditCard,
    Gift,
    Grid3X3,
    Image,
    LayoutDashboard,
    Megaphone,
    Receipt,
    ShoppingBag,
    Users
} from 'lucide-react';
import './ManageClubs.css';

const navItems = [
    { label: 'Venue Dashboard', icon: LayoutDashboard, to: (clubId) => `/dashboard/club/${clubId}/dashboard`, end: true },
    { label: 'Events', icon: Calendar, to: (clubId) => `/dashboard/club/${clubId}/events` },
    { label: 'Members', icon: Users, to: (clubId) => `/dashboard/club/${clubId}/members` },
    { label: 'Stands', icon: Grid3X3, to: (clubId) => `/dashboard/club/${clubId}/stands` },
    { label: 'Maps & Photos', icon: Image, to: (clubId) => `/dashboard/club/${clubId}/media` },
    { label: 'Connect Perks', icon: Gift, to: (clubId) => `/dashboard/club/${clubId}/offers` },
    { label: 'Marketplace / Shopfront', icon: ShoppingBag, to: (clubId) => `/dashboard/club/${clubId}/storefront` },
    { label: 'Communications', icon: Megaphone, to: (clubId) => `/dashboard/club/${clubId}/communications` },
    { label: 'Till / POS', icon: Receipt, to: (clubId) => `/dashboard/club/${clubId}/till` },
    { label: 'Venue Plan', icon: CreditCard, to: (clubId) => `/dashboard/club/${clubId}/plan` }
];

const VenueSubnav = ({ clubId }) => (
    <nav className="venue-subnav" aria-label="Venue management sections">
        {navItems.map((item) => {
            const Icon = item.icon;
            return (
                <NavLink
                    key={item.label}
                    to={item.to(clubId)}
                    end={item.end}
                    className={({ isActive }) => `venue-subnav-link${isActive ? ' active' : ''}`}
                >
                    <Icon size={16} />
                    <span>{item.label}</span>
                </NavLink>
            );
        })}
    </nav>
);

export default VenueSubnav;
